import { useMemo, useState } from 'react'
import { getTps } from '../../../../services/localstorage/localstorage.service'
import InsumoHttp from '../../../../services/api/https/insumos/insumo.http'

export const LOADING_MESSAGES = {
  NONE: 'none',
  FETCH_INSUMOS: 'Carregando os Insumos Cadastrados',
}

const NEW_INSUMO = {
  id: null,
  name: '',
  unidadeMovimentacao: '',
  allowedTps: [],
}
const INIT_STATE = {
  loadingMessage: LOADING_MESSAGES.NONE,
  errorMessage: null,
  insumos: [],
  showModal: false,
  selectedInsumo: null,
}
export default function useCadastroInsumo() {
  const [state, setState] = useState({ ...INIT_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      setLoadingMessageTo(msg) {
        setState(prevState => ({ ...prevState, loadingMessage: msg }))
      },

      fetchInsumos(tpId) {
        InsumoHttp.getInsumos(tpId)
          .then(insumos => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOADING_MESSAGES.NONE,
              insumos,
            }))
          })
          .catch(e => {
            setState(prevState => ({
              ...prevState,
              errorMessage: e,
              loadingMessage: LOADING_MESSAGES.NONE,
            }))
          })
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOADING_MESSAGES.NONE,
          errorMessage: null,
        }))
      },

      // Events
      onMenuItemClick(selectedInsumo) {
        setState(prevState => ({ ...prevState, showModal: true, selectedInsumo }))
      },

      onBtnNovo() {
        const userTps = getTps(false)
        if (Array.isArray(userTps) && userTps.length > 0) {
          const allowedTps = userTps.map(t => ({ ...t, active: false }))
          const newInsumo = { ...NEW_INSUMO, allowedTps }
          setState(prevState => ({ ...prevState, showModal: true, selectedInsumo: newInsumo }))
        } else {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Não existe TP associado a este Usuário',
          }))
        }
      },

      onModalResponse(action, payload) {
        if (action === 'close') {
          setState(prevState => ({ ...prevState, showModal: false, selectedInsumo: null }))
        } else if (action === 'error') {
          setState(prevState => ({ ...prevState, errorMessage: payload }))
        } else if (action === 'success') {
          setState(prevState => {
            const index = prevState.insumos.findIndex(i => i.id === payload.id)
            if (index !== -1) {
              prevState.insumos[index] = payload
            } else {
              prevState.insumos.push(payload)
            }
            return { ...prevState, insumos: [...prevState.insumos], showModal: false }
          })
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
